import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  disable () {
    this.element.classList.add('disabled')
    this.element.setAttribute('aria-disabled', 'true')
  }
}
